import { omit } from 'lodash';
import React from 'react';
import { Image } from './styles';
import { DynamicImageProps } from './types';
import { generateThumborImgUrl } from './utils';

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340682375602
 */
export const DynamicImage: React.FC<DynamicImageProps> = (props) => {
  const { height, width, sourceHeight, sourceWidth, src } = props;
  if (!src) {
    console.error('Dynamic image is missing path!');
    return null;
  }

  if (!sourceHeight && !sourceWidth) {
    console.error('Dynamic image is missing source size!');
    return null;
  }

  const imageHeightString = typeof height === 'number' ? `${height}px` : height;
  const imageWidthString = typeof width === 'number' ? `${width}px` : width;

  const imageSrc = generateThumborImgUrl({ src, width: sourceWidth, height: sourceHeight });

  return (
    <Image
      className={props.className ?? ''}
      {...omit(props, ['className', 'sourceHeight', 'sourceWidth', 'objectPosition'])}
      width={imageWidthString}
      height={imageHeightString}
      src={imageSrc}
      alt={props.alt}
      data-resized
      threshold={300}
    />
  );
};
